angular.module('aprima-provider-api').factory('DiagnosisSummaryRepository',
    ['AprimaRestangular', 'AprimaAnalytics', 'ServerInfoRepository', function (AprimaRestangular, AprimaAnalytics, ServerInfoRepository) {
        'use strict';

        return {
            getDiagnosisSummaries: getDiagnosisSummaries,
            getDiagnosisSummary: getDiagnosisSummary
        };

        function getDiagnosisSummaries(patientId, restangularOptions) {
            if (ServerInfoRepository.isFeatureSupported('DiagnosisSummary')) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                var timing = AprimaAnalytics.startTiming('DiagnosisSummaryRepository', 'api', 'get diagnosis summaries');
                var restangular = AprimaRestangular.get(restangularOptions);
                return restangular
                    .one('patients/' + patientId + '/diagnosis-summaries/')
                    .get()
                    .finally(timing.stop);
            }
            else {
                throw new Error('Unsupported feature of getting Diagnosis Summaries');
            }
        }

        function getDiagnosisSummary(patientId, summaryId, restangularOptions) {
            if (ServerInfoRepository.isFeatureSupported('DiagnosisSummary')) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                var timing = AprimaAnalytics.startTiming('DiagnosisSummaryRepository', 'api', 'get diagnosis summary');
                var restangular = AprimaRestangular.get(restangularOptions);
                return restangular
                    .one('patients/' + patientId + '/diagnosis-summaries/' + summaryId)
                    .get()
                    .finally(timing.stop);
            }
            else {
                throw new Error('Unsupported feature of getting Diagnosis Summary');
            }
        }
    }]);

